<template>
  <b-modal id="retrieve-configuration" title="Retrieve configuration" size="lg" centered ok-only>
    <div class="logged-in">
      <h3>Saved configurations</h3>
      <div class="form-group">
        <label for="loginEmailInput">Your email</label>
        <input class="form-control" type="email" name="email" v-model="loginEmailInput" id="loginEmailInput">
      </div>
      <button class="btn btn-black-bg" @click="loadConfigurations">Load configurations</button>
      <div class="user-configurations mt-3">
        <div v-if="loggedUserConfigurations.length == 0">
          <span class="general-content">
            Currently there are no saved configuration
          </span>
        </div>
        <table style="width: 100%" v-else>
          <tr v-for="configuration in loggedUserConfigurations" v-bind:key="configuration.id"
            @click="$bvModal.hide('retrieve-configuration')">
            <td>{{ configuration.id }}</td>
            <td>
              <a :href="'/configurator/?load=' + configuration.id" v-if="getBikeById(configuration.bike_id) != null">{{
                getBikeById(configuration.bike_id).name
              }}</a>
            </td>
            <td>
              <a :href="'/configurator/?load=' + configuration.id">
                {{ formatDate(configuration.created_at) }}
              </a>
            </td>
          </tr>
        </table>
      </div>
    </div>

  </b-modal>
</template>

<script>
import axios from "axios"

export default {
  name: "configuration-modal",
  data() {
    return {

    }
  },
  created() {
    //this.loadConfigurations();
  },
  props: [
    "loggedUser",
    "loginEmailState",
    "loginEmail",
    "loginPasswordState",
    "loginPassword",
    "loggedUserConfigurations",
    "bikes"
  ],
  computed: {
    loginEmailInput: {
      get: function () {
        return this.loginEmail;
      },
      set: function (e) {
        this.$emit("set-login-email", e);
      },
    },
    loginPasswordInput: {
      get: function () {
        return this.loginPassword;
      },
      set: function (e) {
        this.$emit("set-login-password", e);
      },
    },
  },
  methods: {
    loadConfigurations: function () {
      if (this.loginEmail == null || this.loginEmail == "") {
        this.$emit('set-error', 'Insert a valid email address');
        return [];
      }
      axios
        .get("/api/mtm-configurator/configurations/load/" + this.loginEmail)
        .then((res) => {
          this.$emit('set-login-res', res.data);
        })
        .catch(function (error) {
          if (error.response) {
            this.$emit('set-error', 'Cannot load configuration. Error: ' + error.response.data.error);
          }
        });
    },
    getBikeById: function (id) {
      return this.bikes.filter((e) => {
        if (e.id == id) {
          return e;
        }
      })[0];
    },
    formatDate: function (datestr) {
      const date = new Date(datestr);

      // Ottiene i valori di giorno, mese, anno, ora e minuti dalla data
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear().toString();
      const hours = date.getHours().toString().padStart(2, '0');
      const minutes = date.getMinutes().toString().padStart(2, '0');

      // Formatta la data e l'ora nel formato richiesto
      return `${day}-${month}-${year} ${hours}:${minutes}`;
    }
  },
};
</script>
